import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteZoneFailed, deleteZoneSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteZone(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/zone/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === OK) {
      yield put(deleteZoneSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteZoneFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteZoneFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
